import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../components";
const AddOffCycle = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      offCycleName: "",
      selectPayDate: "",
      fromDate: "",
      toDate: "",
      reasonRemarks: "",
    },
    {
      offCycleName: { type: "text", required: true },
      selectPayDate: { type: "select", required: true },
    }
  );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };
  return (
    <Modal
      title={"Add off-cycle"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-5xl"
    >
      <div>
        <div className="grid grid-cols-2 mt-4 gap-x-6 gap-y-4 max-w-3xl">
          <FormFieldSet
            type="text"
            title={"Off-Cycle Name"}
            placeholder="Select Invoice Category"
            value={formData.offCycleName}
            onChange={(value) => handleChange("offCycleName", value)}
            error={errors.offCycleName}
          />
          <FormFieldSet
            type="datepicker"
            title={"Select Pay Date"}
            placeholder="Select Invoice Category"
            value={formData.selectPayDate}
            onChange={(value) => handleChange("selectPayDate", value)}
            error={errors.selectPayDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"From Date"}
            placeholder="Select From Date"
            value={formData.fromDate}
            onChange={(value) => handleChange("fromDate", value)}
            error={errors.fromDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"To Date"}
            placeholder="Select To Date"
            value={formData.toDate}
            onChange={(value) => handleChange("toDate", value)}
            error={errors.toDate}
            showDropdown={false}
          />
          <div className="col-span-2">
            <FormFieldSet
              type="textArea"
              title={"Reason/Remarks"}
              placeholder="Enter "
              value={formData.reasonRemarks}
              onChange={(value) => handleChange("reasonRemarks", value)}
              error={errors.reasonRemarks}
            />
          </div>
        </div>
        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Create" onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default AddOffCycle;
